import { ConfigObj, DomHelpers, PubSub, CssModifiers } from '../utils'

const MODULE_NAME = 'ps-country-selector'

const defaultOpts = {
  modifierOpen: 'm-is-open'
}

const SELECTOR = {
  FLAG : `${MODULE_NAME}__flag`,
  ITEM: `${MODULE_NAME}__item`,
  LABEL: `${MODULE_NAME}__label`,
  LIST: `${MODULE_NAME}__list`
}

let siteUrlCookie = document.cookie.match(/_site_url_name=(\w+)/)[1]

let countries = [
  { label: 'United Kingdom', lang: 'en-gb', site: 'uk', isActive: false},
  { label: 'Ireland', lang: 'en-ie', site: 'ie', isActive: false}
]



/**
 * Initialize the script
 */
export default class CountrySelector {
  constructor($el, opts) {
    this.$el = $el
    this.options = ConfigObj.merge(defaultOpts, opts)
    this.$label = this.$el.querySelector(`.${SELECTOR.LABEL}`)
    this.$list = this.$el.querySelector(`.${SELECTOR.LIST}`)
    this.isOpen = false
  }


  init() {
    this.activeItem.set(siteUrlCookie)
    this.$list.innerHTML = this.createListItems()

    this.setLabel()

    //Add event listener
    this.addEventListeners()
  }


  activeItem = {
    get: () => countries.filter(country => country.isActive == true)[0],
    set: (site) => countries = countries.map(country => {
      country.isActive = country.site == site
      return country
    })
  }

  // Add Label
  setLabel() {
    this.$label.innerHTML = `<span class="${SELECTOR.FLAG}" m-country-${this.activeItem.get().site}></span>${this.activeItem.get().label}`;
  }

  // Render all countries on the dropdown
  createListItems() {
    return countries.map(item => {
      if (item.isActive == false) {
        return `<li class="${SELECTOR.ITEM}" data-site=${item.site}><span class="${SELECTOR.FLAG}" m-country-${item.site} ></span>${item.label}</li>`;
      }
    }).join('');

  }

  setCountry(e) {
    this.activeItem.set(e.target.dataset.site)
    
    const activeItem = this.activeItem.get()
    this.setLabel()

    //Overriding Cookie
    document.cookie = `preferredSite=${activeItem.lang}; path=/;`

    // Redirecting website to selected country
    window.location = `/${activeItem.site}`
  }

  toggleState(isOpen = false) {
    this.isOpen = isOpen
    CssModifiers.toggle(this.$el, isOpen, this.options.modifierOpen)
  }

  //Close dropdown if user click anywhere on the page
  closeDropDown(e) {
    if (e.target != this.$label) {
      this.toggleState()
    }
  }


  onClick(e) {
    DomHelpers.delegateEvent(e, `.${SELECTOR.ITEM}`, this.setCountry.bind(this))
    DomHelpers.delegateEvent(e, `.${SELECTOR.LABEL}`, this.toggleState.bind(this, !this.isOpen))

    e.preventDefault()
  }


  // Add event Listeneer
  addEventListeners() {
    document.addEventListener('click', this.closeDropDown.bind(this))
    this.$el.addEventListener('click', this.onClick.bind(this))
  }

}



// WEBPACK FOOTER //
// ./js/modules/CountrySelector.js